

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      ventast_tabla: 0,
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
        estado: false
      }

    };
  },

  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      dom: 'Bfrtip',
      buttons: ['excelHtml5'],



    });
    $('.box').boxWidget();

   // this.consultar();

  },

  methods: {
    consultar() {
      this.loading = true;

      this.tbv.clear();



      let fl = 0;
      if (this.f_c.estado) {
        fl = 1;
        var column2 = this.tbv.column(4)
        column2.visible(false);
        var column2 = this.tbv.column(2)
        column2.visible(false);
      } else {
        fl = 0;
        var column2 = this.tbv.column(4)
        column2.visible(true);

        var column2 = this.tbv.column(2)
        column2.visible(true);
      }

      this.f_c.estado = fl;

      this.$http
        .post('/SERVER/scd/reportes/', {
          'a': 'resumenloteequi2',
          'f': this.f_c
        }, {
          withCredentials: true
        })
        .then(response => {
          this.ventast_tabla = 0;
          if (response.data.status == 1) {


            for (let i = 0; i < response.data.data.length; i++) {
              this.ventast_tabla += parseFloat(response.data.data[i][7]);
              response.data.data[i][7] = this.num_to_many(response.data.data[i][7]);
              response.data.data[i][8] = this.num_to_many(response.data.data[i][8]);
              response.data.data[i][9] = this.num_to_many(response.data.data[i][9]);
              response.data.data[i].push('<button disabled type="button" class="btn btn-default">Detalle</button>');
              this.tbv.row.add(response.data.data[i]);

            }



            this.ventast_tabla = this.num_to_many(this.ventast_tabla.toFixed(2));

          }
          this.tbv.draw();

          this.loading = false;
        });

    },

  }


};



// WEBPACK FOOTER //
// ./src/components/reportes/resumenloteequi/tventas/tventas.js